import kotlinx.browser.document
import org.w3c.dom.HTMLElement
import features.auth.AuthFeature

object Router {
    private var modalsInitialized = false
    
    fun navigateTo(page: String) {
        console.log("🔄 Router.navigateTo called with page: $page")
        console.log("📍 Current page before: ${AppState.currentPage}")
        AppState.currentPage = page
        console.log("📍 Current page after: ${AppState.currentPage}")
        console.log("🎨 Calling render()...")
        render()
        console.log("✅ render() completed")
    }
    
    fun render() {
        console.log("🎨 Router.render() called")
        console.log("📄 Current page: ${AppState.currentPage}")
        
        val root = document.getElementById("root") as? HTMLElement
        if (root == null) {
            console.error("❌ Root element not found!")
            return
        }
        console.log("✅ Root element found")
        
        root.innerHTML = ""
        console.log("🧹 Root innerHTML cleared")
        
        when (AppState.currentPage) {
            "login" -> {
                console.log("🔐 Rendering login page")
                features.auth.ui.LoginPage.render(root)
            }
            "home" -> {
                console.log("🏠 Rendering home page")
                features.home.ui.HomePage.render(root)
            }
            "teams" -> {
                console.log("👥 Rendering teams page")
                features.teams.ui.TeamListPage.render(root)
            }
            "profile" -> {
                console.log("👤 Rendering profile page")
                features.profile.ui.ProfilePage.render(root)
            }
            "dashboard" -> {
                console.log("📊 Rendering dashboard (redirecting to teams)")
                // Redirect dashboard to teams page
                AppState.currentPage = "teams"
                features.teams.ui.TeamListPage.render(root)
            }
            "team-detail" -> {
                console.log("🏢 Rendering team detail")
                features.teams.ui.TeamDetailPage.render(root)
            }
            else -> {
                console.log("⚠️ Unknown page, rendering login...")
                AuthFeature.renderLoginPage(root)
            }
        }
        console.log("✅ Page rendered")
        
        // Setup modals once
        if (!modalsInitialized) {
            console.log("🎭 Setting up modals...")
            val body = document.body as? HTMLElement
            if (body != null) {
                shared.ui.ModalManager.setupModalOverlay(body)
                modalsInitialized = true
                console.log("✅ Modals initialized")
            } else {
                console.error("❌ Body element not found!")
            }
        }
    }
}
